module.exports = __webpack_public_path__ + "fonts/lato-black-webfont.3d2a00b7.ttf";